/**
 * orga-app-api - pandemie-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LandkreisInzidenz { 
    landkreis_id: string;
    faelle_7_tage_pro_100k?: number;
    anzeige?: string;
    aktualisiert_utc?: Date;
    einwohnerzahl?: number;
}

